import React from 'react';
import { useSelector } from 'react-redux';

/**
 * USAGE
 * make a <Footnote id="" content=""/> where you want the superscript in the content (title)
 * add <Footnotes /> where you want the actual footnotes content to render
 * page.js has a footerFootnotes flag to place the footnotes in the Footer
 **/

const Footnotes = () => {
  const footnotes = useSelector((redux) => redux?.footnotes);

  return (
    <div id="footnotes-block" className="footnotes-container">
      {[...footnotes.values()].map((f) => (
        <React.Fragment key={f.id}>
          <div className="footnote-symbol" id={`footnote-symbol-${f.id}`}>
            <b>{f.symbol}</b>
          </div>
          <div className="footnote-message" id={`footnote-message-${f.id}`}>
            {f.message}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

export default Footnotes;
